import React from 'react';
import ErrorBoundary from 'Views/Onboarding/Components/ErrorBoundary';
import OnboardingContainer from 'Views/OnboardingExperimental/OnboardingExperimentalContainer';

const OnboardingExperimental = () => {
  return (
    <ErrorBoundary>
      <OnboardingContainer />
    </ErrorBoundary>
  );
};

export default OnboardingExperimental;
